module.exports = __webpack_public_path__ + "static/img/touxiang.e7e0d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/touxiang.png
// module id = 5p8L
// module chunks = 1